import { BRAND } from "@/lib/brand";

export const Logo = ({ variant = "global", onDark = false, className = "h-10 w-auto" }) => {
  const isHealth = variant === "health";
  const src = isHealth
    ? BRAND.health.logo
    : onDark
      ? BRAND.global.logoOnDark
      : BRAND.global.logoOnLight;
  const alt = isHealth
    ? "Azeka Health — Pure Wellbeing"
    : "Azeka Global Trade FZCO";
  return <img src={src} alt={alt} className={className} draggable="false" />;
};
